// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { U128, U128T, verifyU128 } from "../u128/u128";

export class Uuid implements flatbuffers.IUnpackableObject<UuidT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): Uuid {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsUuid(bb: flatbuffers.ByteBuffer, obj?: Uuid): Uuid {
    return (obj || new Uuid()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsUuid(bb: flatbuffers.ByteBuffer, obj?: Uuid): Uuid {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new Uuid()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  value(obj?: U128): U128 | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new U128()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  static startUuid(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addValue(builder: flatbuffers.Builder, valueOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, valueOffset, 0);
  }

  static endUuid(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // value
    return offset;
  }

  static createUuid(
    builder: flatbuffers.Builder,
    valueOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    Uuid.startUuid(builder);
    Uuid.addValue(builder, valueOffset);
    return Uuid.endUuid(builder);
  }

  unpack(): UuidT {
    return new UuidT(this.value() !== null ? this.value()!.unpack() : null);
  }

  unpackTo(_o: UuidT): void {
    _o.value = this.value() !== null ? this.value()!.unpack() : null;
  }

  unpackFields(...fields: string[]): UuidT {
    const t = new UuidT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("value")) {
      t.value = this.value() !== null ? this.value()!.unpack() : null;
    }
    return t;
  }
}

export class UuidT implements flatbuffers.IGeneratedObject {
  constructor(public value: U128T | null = null) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.value === null || this.value === undefined) {
      throw new Error('Required field "value" is not set');
    }
    const value = this.value !== null ? this.value!.pack(builder) : 0;

    return Uuid.createUuid(builder, value);
  }

  clone(): UuidT {
    const obj = new UuidT();
    obj.value = this.value !== null ? this.value!.clone() : null;
    return obj;
  }

  equals(other: UuidT): boolean {
    if (this.value !== null && other.value !== null) {
      if (!this.value!.equals(other.value!)) return false;
    } else if (this.value !== other.value) return false;
    return true;
  }
}

export function verifyUuid(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyU128(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "value");
  } finally {
    verifier.popDepth();
  }
}
